// Framework and third-party non-UI
import React from 'react';

// Redux, contexts, and local helpers/utils/modules

// Component specific modules (Component-styled, etc.)
import {
  CodeDataGridCell,
  FixedHelperDataGrid,
  StyledCaption,
  StyledCodeCopy,
  StyledHelperButton,
  StyledHelperP,
  StyledHelperPanel,
  StyledHelperPopover
} from './DateTimeFormatHelp-styled';

// App components
import CopyToClipboard from 'components/CopyToClipboard';
import {
  DataGridHeader,
  DataGridHeaderRow,
  DataGridHeaderCell,
  DataGridBody,
  DataGridRow,
  DataGridCell
} from 'components/DataGrid';

// Third-party components (buttons, icons, etc.)
import { CalciteLink } from 'components/Calcite';

const DateTimeFormatHelp: React.FC = () => (
  <>
    <StyledHelperPopover
      focusTrapDisabled
      label="How to write a formatter"
      placement="bottom"
      referenceElement="format-helper-btn"
    >
      <StyledHelperPanel>
        <FixedHelperDataGrid noCol noRow>
          <StyledCaption>Example Formats</StyledCaption>
          <DataGridHeader>
            <DataGridHeaderRow>
              <DataGridHeaderCell>Date and time pattern</DataGridHeaderCell>
              <DataGridHeaderCell>
                Datetime formatting string
              </DataGridHeaderCell>
            </DataGridHeaderRow>
          </DataGridHeader>
          <DataGridBody>
            <DataGridRow>
              <CodeDataGridCell>2019-04-05T12:05:18.095Z</CodeDataGridCell>
              <DataGridCell>
                <StyledCodeCopy>yyyy-MM-dd'T'HH:mm:ss.SSS'Z'</StyledCodeCopy>
                <CopyToClipboard
                  copyValue="yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
                  name="milliseconds"
                />
              </DataGridCell>
            </DataGridRow>
            <DataGridRow>
              <CodeDataGridCell>12/27/2015 16:39:20</CodeDataGridCell>
              <DataGridCell>
                <StyledCodeCopy>MM/dd/yyyy HH:mm:ss</StyledCodeCopy>
                <CopyToClipboard
                  copyValue="MM/dd/yyyy HH:mm:ss"
                  name="us-date"
                />
              </DataGridCell>
            </DataGridRow>
            <DataGridRow>
              <CodeDataGridCell>2019-06-01T03:54:09+00:00</CodeDataGridCell>
              <DataGridCell>
                <StyledCodeCopy>yyyy-MM-dd'T'HH:mm:ssZZ</StyledCodeCopy>
                <CopyToClipboard
                  copyValue="yyyy-MM-dd'T'HH:mm:ssZZ"
                  name="timezone"
                />
              </DataGridCell>
            </DataGridRow>
          </DataGridBody>
        </FixedHelperDataGrid>
        <StyledHelperP>
          For more information on writing a date format see the{' '}
          <CalciteLink
            href="https://docdev.arcgis.com/en/iot/ingest/define-date-and-time-properties.htm"
            rel="noopener noreferrer"
            target="_blank"
          >
            documentation
          </CalciteLink>
          .
        </StyledHelperP>
      </StyledHelperPanel>
    </StyledHelperPopover>
    <StyledHelperButton id="format-helper-btn">
      How to write a formatter
    </StyledHelperButton>
  </>
);

export default DateTimeFormatHelp;
